import React from 'react';
import { ClientShowCaseListContentfulModel } from 'src/api/models/ClientsShowCase';
import ClientShowCase from 'src/organisms/carousels/ClientShowCase.pro';
import styled from 'styled-components';

const DynamicClientShowCaseContainer = styled.div`
  height: 100%;
  width: 100%;
`

export default function getDynamicClientShowCaseList(clientShowCaseListProps: ClientShowCaseListContentfulModel): React.ReactNode {
  return (
    <DynamicClientShowCaseContainer>
      <ClientShowCase cases={clientShowCaseListProps.cases} />
    </DynamicClientShowCaseContainer>
  )
}
